import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';

/**
 * The answer to a question as the reader chose it: the labels of the options picked rather than
 * their values
 */
export default function getAnswerLabel(field: FormField, value: unknown): string | null {
    if (value === null || typeof value === 'undefined' || value === '') {
        return null;
    }
    const { options = [] } = field as OptionsField;
    const getLabel = (item: unknown) => {
        const { label = null } = options.find((option) => option.value === item) || {};
        return label !== null ? label.trim() : String(item);
    };
    if (isArray(value)) {
        return value.map(getLabel).join(', ');
    }
    if (isObject(value)) {
        return Object.values(value).map(getLabel).join(', ');
    }
    return getLabel(value);
}
